import { createAsyncThunk } from "@reduxjs/toolkit";
import { getInfrastructureArchitecturePossibleServicesThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitecturePossibleServicesThunk";
import { getInfrastructureArchitecturePossibleRegionsThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitecturePossibleRegionsThunk";
import { selectInfrastructureArchitectureStateInLocalStorage } from "@/store/infrastructure-architecture/utils/helpers/selectInfrastructureArchitectureStateInLocalStorage";
import { setInfrastructureArchitectureRequestData } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";
import { getInfrastructureArchitectureDiagramThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitectureDiagramThunk";
import { getInfrastructureArchitectureRecommendationThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitectureRecommendationThunk";

export const initiateInfrastructureArchitectureThunk = createAsyncThunk(
  "infrastructureArchitecture/initiateInfrastructureArchitecture",
  async (_, { dispatch }) => {
    try {
      const { requestData, recommendationData, diagramData } =
        selectInfrastructureArchitectureStateInLocalStorage();

      await Promise.all([
        dispatch(getInfrastructureArchitecturePossibleServicesThunk()).unwrap(),
        dispatch(getInfrastructureArchitecturePossibleRegionsThunk()).unwrap(),
      ]);

      if (requestData) {
        dispatch(setInfrastructureArchitectureRequestData(requestData));

        if (!diagramData) {
          await dispatch(getInfrastructureArchitectureDiagramThunk()).unwrap();
        }

        if (!recommendationData) {
          await dispatch(
            getInfrastructureArchitectureRecommendationThunk(),
          ).unwrap();
        }
      }
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
